<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="1" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container from '@/components/Container.vue';
export default {
  name: 'R07',
  data () {
    return {

      Bignav: false,
      Container:{
        subtitle:'',
        videosrc:'R07.mp4',
        title:'精準治療．守護腦部功能',
        list:[
          {
            title:'精準治療．守護腦部功能',
            body:"放射治療利用高精準放射線，消滅腫瘤及殘存癌細胞、降低腫瘤復發風險，同時盡可能保護周圍正常腦組織。透過精準治療，可協助維持神經功能，減少疾病對日常生活的影響，提升治療效果與生活品質。"
          },
          {
            title:'治療的重要價值',
            body:["提高腫瘤局部控制率","降低腫瘤復發風險","保護正常腦組織與神經功能","提升治療效果與生活品質"]
          }
        ]
      }

    }
  },
  components: {
    Back,Container,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
